import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useAuth } from "./AuthContext";
import API from "../services/APIDeprecated";


const AnalyticsContext = createContext();

export const useAnalytics = () => useContext(AnalyticsContext);

export const AnalyticsProvider = ({ children }) => {
  const { organizationId } = useAuth();
  const lastFetchKeyRef = useRef("");
  const [dateRange, setDateRange] = useState({
    startDate: "2024-01-01",
    endDate: "2024-02-09",
  });
  const [insights, setInsights] = useState(null);
  const [sessions, setSessions] = useState(null);

  const [statistics, setStatistics] = useState(null);

  const [activeInsightSort, setActiveInsightSort] = useState({ attribute: "", order: true }); // order: true for ascending, false for descending

   const [activeSessionSort, setActiveSessionSort] = useState({
     attribute: "",
     order: true,
   });

  const updateData = useCallback(() => {
    if (!organizationId || !dateRange?.startDate || !dateRange?.endDate) return;

    API.get(
      `questions?organization=${organizationId}&start=${dateRange.startDate}&end=${dateRange.endDate}`,
      {
        requiresAuth: true,
      }
    )
      .then((response) => {
        console.log("INSIGHT response", response);
        response && sortList(response.data, setInsights, "responseCount", false, setActiveInsightSort);
      })
      .catch((error) => console.log(error));

    API.get(
      `sessions?organization=${organizationId}&start=${dateRange.startDate}&end=${dateRange.endDate}`,
      {
        requiresAuth: true,
      }
    )
      .then((response) => {
        console.log("SESSION response", response);
        if (response){
          sortList(response.data, setSessions, "startTime", false, setActiveSessionSort);
          
        }
          
      })
      .catch((error) => console.log(error));

    API.get(
      `stats?organization=${organizationId}&start=${dateRange.startDate}&end=${dateRange.endDate}`,
      {
        requiresAuth: true,
      }
    )
      .then((response) => {
        console.log("STAT response", response);
        response && response.data.averageResponses != "NaN" && setStatistics(response.data);
      })
      .catch((error) => console.log(error));
  }, [organizationId, dateRange?.startDate, dateRange?.endDate]);

  useEffect(() => {
    if (!organizationId || !dateRange?.startDate || !dateRange?.endDate) return;

    const fetchKey = `${organizationId}|${dateRange.startDate}|${dateRange.endDate}`;
    if (lastFetchKeyRef.current === fetchKey) return;

    lastFetchKeyRef.current = fetchKey;
    updateData();
  }, [organizationId, dateRange?.startDate, dateRange?.endDate, updateData]);

  useEffect(() => {
    // console.log("insights updated", insights)
  }, [insights]);

  const sortSessions = (attribute, ascending = true) => {
    sortList(sessions, setSessions, attribute, ascending, setActiveSessionSort);

  };

  const sortInsights = (attribute, ascending = true) => {
    sortList(insights, setInsights, attribute, ascending, setActiveInsightSort);

  };

  const sortList = (list, setList, attribute, ascending = true, setActiveSort) => {
    const sortedList = [...list].sort((a, b) => {
      if (a[attribute] < b[attribute]) {
        return ascending ? -1 : 1;
      }
      if (a[attribute] > b[attribute]) {
        return ascending ? 1 : -1;
      }
      return 0;
    });
  
    setActiveSort({ attribute, order: ascending });
    setList(sortedList);
  };

  const updateDateRange = useCallback((newDateRange) => {
    if (!newDateRange?.startDate || !newDateRange?.endDate) return;

    setDateRange((previousRange) => {
      if (
        previousRange?.startDate === newDateRange.startDate &&
        previousRange?.endDate === newDateRange.endDate
      ) {
        return previousRange;
      }

      return newDateRange;
    });
  }, []);

  const value = {
    insights,
    sortInsights,
    activeInsightSort,
    sessions,
    sortSessions,
    activeSessionSort,
    statistics,
    updateDateRange,
   
  };

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
}
